import { Box, useColorScheme } from "@mui/joy";
import { useColorScheme as useMaterialColorTheme } from "@mui/material/styles";
import Activity from "components/task/Activity";
import { useEffect, useRef } from "react";
import logo from "static/logo.png";

export default function MeditationTool() {
  const { setMode } = useColorScheme();
  const { setMode: setMaterialMode } = useMaterialColorTheme();

  useEffect(() => {
    setMode("light");
    setMaterialMode("light");
  }, []);

  useEffect(() => {
    const setThemeColor = (color: string) => {
      let themeColorMetaTag = document.querySelector(
        'meta[name="theme-color"]'
      );
      if (!themeColorMetaTag) {
        themeColorMetaTag = document.createElement("meta");
        themeColorMetaTag.setAttribute("name", "theme-color");
        document.head.appendChild(themeColorMetaTag);
      }
      themeColorMetaTag.setAttribute("content", color);
    };

    // 예제: 컴포넌트가 마운트될 때 노치 색상을 변경
    setThemeColor("#ffffff");

    // 필요한 경우, cleanup 함수를 사용하여 색상을 초기 상태로 되돌릴 수 있음
    return () => setThemeColor("#E2E6E8"); // 기본 색상
  }, []);

  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        overflow: "scroll",
        pt: "20px",
        // backgroundColor: "background.level1",
      }}
    >
      <img
        src={logo}
        alt={"logo"}
        className="w-[120px] mb-[30px] mx-auto"
      ></img>
      <Activity taskKey="meditationTool" noHeader />
    </Box>
  );
}
